import React, { FC, useState } from "react";
import useClipboard from "react-use-clipboard";
import Divider from "../../atoms/Divider/Divider";
import { Button, Typography } from "../../atoms";
import ListItem from "../../atoms/ListItem/ListItem";
import {
  NATIVE_TOKEN_LABEL,
  NATIVE_TOKEN_MULTIPLIER,
  urls,
} from "@constants/constants";
import styles from "./WalletSelector.module.scss";

import copy_address from "../../../assets/svg/copy_address.svg";
import CheckIcon from "@material-ui/icons/Check";
import { ConnectType } from "context/HashConnectProvider";
import useHashConnect from "@hooks/useHashConnect";
import { WalletStatus } from "./WalletSelector";
import { HashConnectTypes } from "hashconnect";
import { StorageService } from "@services/storage.service";

type WailetsConfig = {
  availableInstallTypes: Array<ConnectType>;
};
interface ConnectedProps {
  disconnectWallet: () => void;
  walletBalance: number;
  truncatedWalletAddress: string;
  walletAddress: string;
}

export const ConnectedWalletModal: FC<ConnectedProps> = (props) => {
  const {
    walletAddress,
    walletBalance,
    truncatedWalletAddress,

    disconnectWallet,
  } = props;

  const [isCopied, setCopied] = useClipboard(walletAddress, {
    successDuration: 1000 * 6,
  });

  return (
    <>
      <ListItem className={"mb-4"}>
        <div className={"flex items-center"}>
          <Typography fontWeight={"bold"} variant={"body2"}>
            {truncatedWalletAddress}
          </Typography>
          {isCopied && (
            <CheckIcon
              fontSize="small"
              style={{
                color: "green",
              }}
            />
          )}
        </div>

        <img alt="img" src={copy_address} onClick={setCopied} />
      </ListItem>
      <Divider color={"gradient"} />
      <ListItem className={"py-4"}>
        <Typography fontWeight={"bold"} variant={"body2"}>
          {NATIVE_TOKEN_LABEL}
        </Typography>
        <Typography fontWeight={"bold"} variant={"body2"}>
          {walletBalance / NATIVE_TOKEN_MULTIPLIER}
        </Typography>
      </ListItem>
      <Divider color={"light"} />

      <Button
        variant={"flat"}
        childClassName={"px-5"}
        parentClassName={"mt-4 self-center"}
        onClick={disconnectWallet}
        size={"small"}
      >
        Disconnect Wallet
      </Button>
    </>
  );
};

interface DisconnectedProps {
  isWalletDisconnected: boolean;
  installedExtensions: HashConnectTypes.WalletMetadata | null;
  isWalletInitializing: boolean;
  isBladeExtensionInstalled: boolean;
  installWallet: (props: ConnectType) => void;
}

export const DisconnectWalletModal: FC<DisconnectedProps> = (props) => {
  const { installWallet } = props;
  const wallet = useWallet();
  const [termsAccepted, setTermsAccepted] = useState<boolean>(
    StorageService.getTerms()
  );
  const {
    isWalletDisconnected,
    installedExtensions,
    isWalletInitializing,
    isBladeExtensionInstalled,
  } = props;

  const termsAcceptedHandle = (checked: boolean) => {
    setTermsAccepted(checked);
    StorageService.saveTerms(checked);
  };

  return (
    <>
      <div className="flex flex-center ">
        <label className={styles.checkbox}>
          <input
            type="checkbox"
            name="accept_terms"
            checked={termsAccepted}
            onChange={(e) => termsAcceptedHandle(e.target.checked)}
          />
        </label>
        <Typography
          fontWeight={"bold"}
          className={"text-white"}
          variant={"caption1"}
        >
          By connecting a wallet, you agree to our{" "}
          <a
            href={urls.termsOfService}
            target="_blank"
            rel="noreferrer"
            className={styles.term_of_service}
          >
            Terms of Service
          </a>
        </Typography>
      </div>
      {wallet.availableInstallTypes.includes(ConnectType.CHROME_EXTENSION) && (
        <Button
          variant={"flat"}
          childClassName={"px-5"}
          parentClassName={"w-full"}
          disabled={!termsAccepted}
          onClick={() =>
            !isWalletInitializing &&
            installWallet(
              isWalletDisconnected && installedExtensions !== null
                ? ConnectType.CHROME_EXTENSION
                : ConnectType.INSTALL_EXTENSION
            )
          }
          size={"small"}
        >
          <Typography fontWeight={"medium"}>
            {isWalletDisconnected && installedExtensions !== null
              ? "HashPack Wallet"
              : isWalletInitializing
              ? "Initializing Wallet..."
              : "Install HashPack Extension"}
          </Typography>
        </Button>
      )}
      {
        <Button
          variant={"flat"}
          childClassName={"px-5 mb-2"}
          parentClassName={"w-full"}
          disabled={!termsAccepted}
          onClick={() => installWallet(ConnectType.BLADE_WALLET)}
          size={"small"}
        >
          {isWalletInitializing ? (
            <Typography fontWeight={"medium"}>
              Initializing Wallet...
            </Typography>
          ) : (
            <Typography fontWeight={"medium"}>
              {isBladeExtensionInstalled ? "" : "Install"} Blade
              {isBladeExtensionInstalled ? " Wallet" : " Extension"}
            </Typography>
          )}
        </Button>
      }
    </>
  );
};

function useWallet(): WailetsConfig {
  return {
    availableInstallTypes: [ConnectType.CHROME_EXTENSION],
  };
}
